<template>
  <v-dialog v-model="dialogTermoLegal" max-width="600px">
    <div class="link" slot="activator">Termos legais</div>
    <v-card>
      <v-card-title>
        <span class="headline">Termos legais</span>
      </v-card-title>
      <v-card-text>
        Os serviços oferecidos neste site, bem como suas marcas, sistemas,
        conteúdo são protegidos por direitos de propriedade intelectual.<br>

        Nosso maior objetivo é oferecer um excelente serviço pela Internet e,
        por isso, poderemos cancelar o cadastro de usuários que venham a
        prejudicar, de alguma forma, o bom funcionamento do site. Portanto,
        fica esclarecido que é expressamente proibida a comercialização,
        reprodução, modificação ou distribuição, de parte ou totalidade das
        informações e todo o conteúdo contido neste site, sem prévia
        autorização.<br>

        Constitui também infração, qualquer uso do site com propósitos ilegais,
        propagação de vírus de computador ou envio de falsificação de endereços
        de máquinas ou de correio eletrônico, na tentativa de ocultar a
        identidade ou autoria, ou de responsabilizar terceiros.<br>

        Todo o conteúdo do site, caso seja necessário, poderá ser alterado ou
        cancelado a qualquer momento sem aviso prévio.<br>

        Com relação ao uso dos "links" apresentados no site, é importante
        salientar que não nos responsabilizamos pelos conteúdos contidos ou
        fornecidos por estes sites, nem por eventuais prejuízos ou danos
        causados pelos mesmos.<br>

        As informações aqui publicadas são passíveis de alterações a qualquer
        tempo, sem prévia notificação do usuário. Para efeito legal, prevalece
        o documento original.<br>

        Nós não nos responsabilizamos por prejuízos da utilização ou não deste
        site.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="blue--text darken-1" flat="flat" @click.native="dialogTermoLegal = false">Ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'termo-legal',
  data () {
    return {
      dialogTermoLegal: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// TermoLegal.vue?70357a46